export * from './boleto.pipe';
export * from './cartao-destino.pipe';
export * from './cartao.pipe';
export * from './conta-bancaria.pipe';
export * from './currency-format.pipe';
export * from './date-format.pipe';
export * from './key-of-value.pipe';
export * from './limit-to.pipe';
export * from './order-by.pipe';
export * from './pagamento.pipe';
export * from './pontos.pipe';
export * from './tributo.pipe';



// WEBPACK FOOTER //
// ./src/app/resources/pipes/index.ts